export default __webpack_public_path__ + "static/media/Tiktok.4c648f30.svg";